"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _Types = require("../../util/Types");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
* Custom Link component
*/
var CustomLinkView = function CustomLinkView(_ref) {
  var column = _ref.column,
    row = _ref.row;
  var _ref2 = column === null || column === void 0 ? void 0 : column.linkAttr,
    rootPath = _ref2.rootPath,
    pathParams = _ref2.pathParams;
  var url = pathParams.map(function (attr) {
    return "#".concat(rootPath, "/").concat(row[attr]);
  });
  return /*#__PURE__*/_react.default.createElement(_core.Link, {
    href: url,
    className: _Types.cellTypes.LINK
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, null, row[column === null || column === void 0 ? void 0 : column.dataField]));
};
var _default = CustomLinkView;
exports.default = _default;